
<script setup>import { ref, onMounted, onUnmounted, defineExpose, nextTick } from 'vue'

// 客户数据（可后续替换为 API）
const clients = ref([])
const info = ref({})
let observer = null

// 设置观察器函数
function setupObserver() {
  if (observer) {
    observer.disconnect()
  }

  observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate__fadeInUp')
            observer.unobserve(entry.target)
          }
        })
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -60px 0px'
      }
  )

  // 观察所有 li 元素
  const elements = document.querySelectorAll('#floor_5_main .channelalbumlist2 li')
  elements.forEach((el) => {
    observer.observe(el)
  })
}

function getInfo(e, data) {
  clients.value = e
  info.value = data

  // 数据更新后重新设置观察器
  nextTick(() => {
    setTimeout(() => {
      setupObserver()
    }, 100)
  })
}

onMounted(() => {
  // 组件挂载后初始化观察器
  nextTick(() => {
    setTimeout(() => {
      setupObserver()
    }, 100)
  })
})

onUnmounted(() => {
  if (observer) {
    observer.disconnect()
  }
})

// 暴露方法给父组件调用
defineExpose({
  getInfo
})
</script>

<template>
  <div id="floor_5_main">
    <div id="floor_5">
      <div class="left_title1">
        <h2><a href="javascript:;">{{info.name}}</a></h2>
        <p>{{info.remark}}</p>
        <i></i>
      </div>
      <div class="left_body1">
        <ul class="channelalbumlist2">
          <!-- 使用 v-for 循环 -->
          <li v-for="(client, index) in clients" :key="index" class="animate__animated">
            <img
                :src="client.picUrl"
                :alt="client.alt"
                :title="client.title"                style="cursor: pointer;"
            />
          </li>
        </ul>
      </div>
      <div class="left_bottom1"></div>
    </div>
  </div>
</template>

<style scoped lang="scss">#floor_5_main .channelalbumlist2 li {
  opacity: 0;
  transform: translateY(30px);

  &.animate__fadeInUp {
    opacity: 1;
    transform: translateY(0);
    animation-name: fadeInUp;
    animation-duration: 0.6s;
  }
}
</style>